import React, { useEffect, useState } from "react";

const CancellationAndRefund = () => {
  const [activeSection, setActiveSection] = useState("");
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showHeaderNotice, setShowHeaderNotice] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
      setShowHeaderNotice(window.scrollY < 100);

      const sections = document.querySelectorAll("section[id]");
      const scrollMiddle = window.scrollY + window.innerHeight / 2;

      let currentId = "";

      sections.forEach((section) => {
        const el = section as HTMLElement;
        const top = el.offsetTop;
        const height = el.offsetHeight;

        if (scrollMiddle >= top && scrollMiddle < top + height) {
          currentId = el.id;
        }
      });

      // Fallback to last section if scrolled to very bottom
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 5
      ) {
        const lastSection = sections[sections.length - 1];
        currentId = lastSection?.id || currentId;
      }

      if (currentId !== activeSection) {
        setActiveSection(currentId);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeSection]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tableOfContents = [
    { id: "cancellation", title: "Cancellation And Refund" },
    { id: "subscriptions", title: "Monthly Subscriptions" },
    { id: "annual", title: "Annual Subscriptions" },
    { id: "partial", title: "Partial Downgrade of Annual Subscription" },
    { id: "auto", title: "Auto-Renewal" },
    { id: "exception", title: "Exception to Our Refund Policy" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <header className="bg-white shadow-md fixed top-0 left-0 w-full z-50">
        <div className="mx-auto px-6 py-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900">
            MOTSOP AI TECHNOLOGIES PRIVATE LIMITED
          </h1>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Cancellation and Refund Policy
          </h2>
          {/* {showHeaderNotice && (
            <p className="text-gray-600 max-w-6xl mx-auto transition-opacity duration-300">
              This Privacy Policy applies to all Motsop AI Technologies
              Private Limited websites that reference this document, along
              with all software products, applications, and services offered
              through those platforms. The comprehensive policy outlined
              below mirrors the structure of this summary and represents the
              binding legal framework governing our data practices.
            </p>
          )} */}
        </div>
      </header>

      {/* Page Body */}
      <div className="pt-[180px] px-6 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Table of Contents */}
          <div className="lg:w-1/4">
            <div
              className={`fixed top-[50px]  left-0 w-1/4 max-w-xs bg-white rounded-lg shadow-lg p-6 border h-[calc(100vh-100px)] overflow-y-auto z-60 mt-20`}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                Table of Contents
              </h3>
              <nav className="space-y-1">
                {tableOfContents.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className={`cursor-pointer transition-colors duration-200 w-full text-left px-3 py-2 rounded-md text-sm flex items-center ${
                      activeSection === item.id
                        ? "bg-blue-100 text-blue-700 font-medium"
                        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                    }`}
                  >
                    <span className="truncate">{item.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="w-full lg:w-3/4">
            <div className="bg-white rounded-lg shadow-lg border p-8 space-y-8">
              {/* Important Notice */}
              <div className="bg-amber-50 border-l-4 border-amber-400 p-6 rounded-r-lg">
                <h3 className="text-lg font-semibold text-amber-800 mb-2">
                  Important Notice
                </h3>
                <p className="text-amber-700">
                  This agreement applies to users based in India. If you are not
                  based in India, our Global Privacy Policy will apply.
                </p>
              </div>

              {/* Section: Cancellation */}
              <section id="cancellation" className="scroll-mt-[100px]">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                  MotSop AI Technologies Customer Satisfaction Policy
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  At MotSop AI Technologies, we are committed to delivering
                  high-quality AI-driven software and services designed to add
                  value to your business or professional operations. We
                  understand that you have multiple options in the market, and
                  we are grateful for the opportunity to serve you. This policy
                  outlines the steps we will take if our services do not meet
                  your expectations.
                </p>
              </section>

              <section id="subscriptions" className="scroll-mt-[100px]">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                  Monthly Subscriptions.
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  If at any point during your first month of using our services
                  you find yourself dissatisfied, please reach out to us. Our
                  team will make every effort to resolve your concern, offer a
                  feasible workaround, or provide a timeline for a satisfactory
                  solution. If the outcome does not meet your needs, we will
                  issue a FULL REFUND for your initial payment and shift your
                  account to the free or basic tier available for that service.
                </p>
              </section>

              <section id="annual" className="scroll-mt-[100px]">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                  Annual Subscriptions.
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  MotSop AI Technologies does not require you to commit to an
                  annual plan to access our solutions. We believe in offering
                  you flexibility and, in return for an annual upfront
                  commitment, extend a considerable discount over our standard
                  monthly pricing. If, within the first 45 days of your annual
                  subscription, you are not satisfied with our service, please
                  contact us. We will try to resolve your issue, offer a
                  workaround, or communicate a timeframe for a proper
                  resolution. If unsatisfied, we will gladly provide you with a
                  FULL REFUND and move your account to the free or basic tier.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  We strive to ensure you remain satisfied throughout the
                  entirety of your subscription—not just during the first 30
                  days (for monthly plans) or 45 days (for annual plans). If, at
                  any point during your subscription period, we remove, break,
                  or discontinue a functionality that was available when you
                  signed up, please notify us promptly. Should we fail to
                  restore that functionality within any promised period or fail
                  to provide a reasonable workaround, you will be entitled to a
                  PRO- RATED REFUND for the remaining subscription period.
                </p>
              </section>

              <section id="partial" className="scroll-mt-[100px]">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                  Partial Downgrade of Annual Subscription.
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  You may occasionally decide to reduce your annual
                  subscription—for example, by decreasing the number of user
                  licenses, changing to a lower-tier plan, removing optional
                  features, or downgrading support levels. In such cases, we
                  will provide compensation in the form of additional time
                  (credit) added to your existing subscription for active
                  licenses. Any applicable discounts will not be considered in
                  the credit calculation. The formula used will be: unused
                  license value = total paid amount - (monthly standard price x
                  number of months used).
                </p>
              </section>

              <section id="auto" className="scroll-mt-[100px]">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                  Auto-Renewal.
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  To ensure uninterrupted access, all monthly and yearly
                  subscriptions are automatically renewed unless you cancel the
                  service. Prior to each renewal, we will notify you of the
                  upcoming charge amount. Following each renewal, we will issue
                  an email receipt containing the charged amount, renewal date,
                  and upcoming renewal details.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  We recognize that sometimes users forget to cancel services
                  they no longer wish to continue. Therefore, if you cancel your
                  subscription within five business days of a monthly renewal or
                  within fifteen days of an annual renewal, you will be eligible
                  for a FULL REFUND. After this grace period, refund
                  requests—including PRO-RATED ones—will not be entertained. For
                  any questions or refund-related requests, please write to:
                  support@motsop.com
                </p>
              </section>

              <section id="exception" className="scroll-mt-[100px]">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                  Exception to Our Refund Policy
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  No FULL or PRO-RATED REFUND will be granted if your account
                  has been suspended, blocked, or terminated due to violations
                  of our Terms of Service. This includes, but is not limited to,
                  activities such as phishing, impersonation, fraudulent
                  conduct, or breaches of applicable laws.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 p-3 bg-blue-600 text-white rounded-full shadow-md hover:bg-blue-700 transition"
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default CancellationAndRefund;
